// App.js
import React from "react";
import { Box } from "@mui/material";
import { AppShell } from "@1823-partners/core";
import Dashboard from "./components/Dashboard";
import api from "./api";

export default function App() {
  return (
    <AppShell appName="recon" title="Recon" api={api}>
      {({ userInfo }) => (
        <Box sx={{ p: 3 }}>
          <Dashboard userId={userInfo?.userDetails} />
        </Box>
      )}
    </AppShell>
  );
}
